import { useNavigate } from 'react-router-dom';
import AppStatePage from '../common/AppStatePage';

const LOCK_ICON = (
  <svg
    width="64"
    height="64"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--rb-color-text-dark-secondary, rgba(0,15,30,0.6))"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <AppStatePage
      statusCode="403 — Access Restricted"
      statusColor="var(--rb-color-accent-negative, #DB0A40)"
      icon={LOCK_ICON}
      title="You don't have access to this page"
      message="This module is outside your current access scope. If you believe this is an error, contact your IT Admin to review your role permissions."
      actions={[
        {
          label: 'Back to Dashboard',
          onClick: () => navigate('/'),
          ariaLabel: 'Go back to Dashboard',
        },
      ]}
    />
  );
}
